import React from "react";
import ProductSlider from "../component/ProductSlider";
import useMetaTags from "../hooks/useMetaTags";
import EnquiryForm from "../component/EnquiryForm";
import { NavLink } from "react-router-dom";
import { serviceCardData } from "../Data/All_Services_Data/allServices";
import ServiceListingSlider from "../component/ServiceListingSlider";
import ClientTestimonialSection from "../component/ClientTestimonialSection";
import BlogListingSlider from "../component/BlogListingSlider";
import DigitalMarketingServicesSection from "../component/DigitalMarketingServicesSection";
import OurWebsiteDevelopment from "../component/OurWebsiteDevelopment";
import BriefIntro from "../component/BriefIntro";
import HeroSection from "../component/HeroSection";

const Test = () => {
  useMetaTags({
    title:
      "WarrgyizMorsch | Complete IT Solutions, Web Development and Digital Marketing",
    description:
      "WarrgyizMorsch offers expert IT solutions, web development and digital marketing services tailored to grow your business. Reliable, efficient, and dedicated support to meet your needs.",
    keywords: "IT solutions, web development and digital marketing company, software development, Custom Web Development Services.",
  });

  // AboutSlider-start-------------------------------
  const aboutSlider = [
    {
      title: "Our Services",
      description:
        "Simplified hiring solutions for your everyday business needs! Ranging from virtual assistants, business process, web and mobile app services.",
      link: "/services",
      btnText: "Explore More",
    },
    {
      title: "Vision Mission & Values",
      description:
        "Our mission, vision and values are the core foundation of our success and commitment to excellence.",
      link: "/about-us",
      btnText: "Explore More",
    },
    {
      title: "Security Measures",
      description:
        "Our network and security department help protect client data and provide security against common IT risks.",
      link: "/about-us",
      btnText: "Explore More",
    },
  ];

  const generateCardHTMLForAboutSlider = (cardContent) => {
    const title = cardContent.title;
    const description = cardContent.description;

    return `      
            <div class="title-area mb-40">
                <span class="sub-title style1 text-white">${title}</span>
                <h5 class="sec-title text-white">${description}</h5>
            </div>
            <a href="${cardContent.link}" class="th-btn style5 style-radius">${cardContent.btnText}</a>
        `;
  };

  const generateSliderHTMLForAboutSlider = (data) => {
    return data.map(generateCardHTMLForAboutSlider);
  };

  const cardHTMLDataForAboutSlider =
    generateSliderHTMLForAboutSlider(aboutSlider);
  // AboutSlider-end-------------------------------

  // gallery-start
  const generateProjectCardHTML = (imageSrc) => {
    return `
        <div class="swiper-slide">
            <div class="project-box">
                <div class="project-img" style="width: 100%; height: 300px; overflow: hidden; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); border-radius: 10px;">
                    <img loading="lazy" src="${imageSrc}" alt="project image" style="width: 100%; height: 100%; object-fit: cover;">
                </div>
            </div>
        </div>
        `;
  };

  const projectImages = [
    "assets/img/gallery/warr/Warrgyizmorsch.pvt.ltd.jpeg",
    "assets/img/gallery/warr/Founder.jpg",
    "assets/img/gallery/warr/CEO.jpg",
    "assets/img/gallery/warr/Warrgyizmorsch Team.jpg",
    "assets/img/gallery/warr/img_1.jpeg",
    "assets/img/gallery/warr/img_2.jpeg",
    "assets/img/gallery/warr/img_3.jpeg",
    "assets/img/gallery/warr/img_4.jpeg",
    "assets/img/gallery/warr/img_5.jpeg",
    "assets/img/gallery/warr/img_6.jpeg",
    "assets/img/gallery/warr/img_7.jpeg",
    "assets/img/gallery/warr/img_8.jpeg",
    "assets/img/gallery/warr/img_9.jpeg",
    "assets/img/gallery/warr/img_10.jpeg",
  ];

  const generateProjectSliderHTML = (images) => {
    return images.map(generateProjectCardHTML);
  };

  const galleryHTMLData = generateProjectSliderHTML(projectImages);

  //gallery-end

  return (
    <>
      <HeroSection />

      {/* Hero section 
      <div className="th-hero-wrapper hero-5" id="hero">
        <div className="hero-inner">
          <div
            className="th-hero-bg"
            data-bg-src="assets/img/hero/hero_first.webp"
            style={{
              backgroundImage: `url('assets/img/hero/hero_first.webp')`,
            }}
          ></div>
          <div className="container th-container5">
            <div
              className="hero-style5"
              style={{
                maxWidth: "100%",
                paddingTop: "80px",
                paddingBottom: "50px",
              }}
            >
              <h1
                className="hero-title text-white"
                style={{ fontSize: "3rem" }}
              >
                Warrgyiz Morsch : <br /> Complete IT Solutions for Your Business
              </h1>
              <p className="hero-text text-white">
                At WarrgyizMorsch, we are experts in providing end-to-end IT solutions that are specifically designed to cater to your business requirements. From robust web development that makes your online presence robust and scalable, to strategic digital marketing that inspires measurable growth - we provide it all at one place. Our expert professionals work towards empowering businesses to excel in a competitive digital world with cutting-edge technology, quick response support, and up-to-the-mark service. Join forces with WarrgyizMorsch and explore the entire potential of your brand through innovative IT solutions.
              </p>
              <div className="btn-group mt-35">
                <NavLink
                  to="/contact-us"
                  className="th-btn style6 style-radius"
                >
                  Contact Us
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Sub hero section  */}
      <div className="th-hero-wrapper hero-3" id="hero">
        <div className="hero-img">
          <img
            src="assets/img/hero/hero_img_3_1.webp"
            loading="lazy"
            alt="Hero"
            title="Hero Image"
          />
          <div className="shape-blur"></div>
        </div>
        <div className="hero-img-phone">
          <img
            src="assets/img/hero/hero_img_3_phone.webp"
            loading="lazy"
            alt="Hero Phone"
            title="Hero Image Phone"
          />
          <div className="shape-blur"></div>
        </div>
        <div className="container">
          <div className="hero-style3">
            <span className="hero-subtitle">WELCOME TO</span>
            <h2 className="hero-title" style={{ fontSize: "2.5rem" }}>
              Warrgyiz Morsch
            </h2>
            <p className="hero-text">
              Your one and only destination for all outsourced services. We believe in providing the best of IT solutions, web development, and digital marketing with full emphasis on meeting deadlines, delivering satisfactory service, and providing 24/7 support. <br />
              Established in 2017, Warrgyiz Morsch has gradually expanded from the beginning, fueled by a desire to assist our clients in growing and thriving. We pride ourselves on providing customized technical and non-technical services that are meant to enhance your business.<br />
              We hope you find our services as enjoyable as we do providing them. Should you have any questions or comments, please feel free to contact us.
            </p>
            <div className="btn-group">
              <NavLink to="/about-us" className="th-btn">
                ABOUT US
                <i className="fa-regular fa-arrow-right ms-2"></i>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="hero-shape1">
          <img
            src="assets/img/hero/hero_shape_3_1.png"
            loading="lazy"
            alt="shape"
            title="shape1"
          />
        </div>
      </div>

      {/* Brief Intro  */}
      <BriefIntro />
      
      {/* Our Services  */}
      <ServiceListingSlider />

      {/* Unique Section  */}
      <div
        className="position-relative overflow-hidden"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div className="container th-container5">
          <div
            className="about-sec4 position-relative overflow-hidden"
            style={{
              backgroundImage: `url('assets/img/normal/about_4.webp')`,
            }}
            data-bg-src=""
          >
            <div className="about-shape4" style={{ borderRadius: "0px" }}>
              <div className="marquee-wrapper">
                <div className="marquee">
                  <div className="marquee-group">
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                  </div>
                  <div aria-hidden="true" className="marquee-group">
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                  </div>
                </div>
                <div className="marquee marquee--reverse">
                  <div className="marquee-group">
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                  </div>
                  <div aria-hidden="true" className="marquee-group">
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                  </div>
                </div>
                <div className="marquee">
                  <div className="marquee-group">
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                  </div>
                  <div aria-hidden="true" className="marquee-group">
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                    <div className="text">Adaptability</div>
                    <div className="text">Creative Innovation</div>
                    <div className="text">4000+ partners</div>
                    <div className="text">15M Customer Worldwide</div>
                    <div className="text">Engagement</div>
                    <div className="text">Ethical Practices</div>
                    <div className="text">Communication</div>
                    <div className="text">Personalization</div>
                    <div className="text">Expertise</div>
                    <div className="text">50+ Countries</div>
                    <div className="text">Expertise</div>
                    <div className="text">Innovation</div>
                    <div className="text">Inclusivity</div>
                    <div className="text">Diversity</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-area4">
              <div className="title-area-wrapper">
                <div className="slider-area p-4">
                  <ProductSlider
                    cardData={cardHTMLDataForAboutSlider}
                    slidesPerView={1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us  */}
      <div className="">
        <div className="container space">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6 mb-30 mb-lg-0">
              <div className="img-box7">
                <div className="img1">
                  <img
                    loading="lazy"
                    src="assets/img/normal/why_2_1.png"
                    alt="Why"
                    title="why_2"
                  />
                </div>
                <div className="color-animate"></div>
              </div>
            </div>
            <div className="col-lg-6 text-lg-start text-center">
              <div className="title-area mb-35">
                <h2 className="sec-title">
                  Why Choose Warrgyizmorsch for Managed IT Solutions
                </h2>
              </div>
              <p>
                Warrgyizmorsch offers some of the best solutions to users at
                affordable prices.
              </p>
              <div>
                <img
                  loading="lazy"
                  src="assets/img/icon/check_1.png"
                  alt="icon"
                />{" "}
                <strong>Custom Solution</strong>
                <p>
                  We provide custom solutions to the business depending upon the
                  need. We focus on fulfilling the goals and objectives of the
                  business.
                </p>
              </div>
              <div>
                <img
                  loading="lazy"
                  src="assets/img/icon/check_1.png"
                  alt="icon"
                />{" "}
                <strong>SEO & Performance Optimization</strong>
                <p>
                  Our expert team ensures that the website is fully optimized.
                  We focus on speed, security, and SEO strategies, all aimed at
                  improving the user experience.
                </p>
              </div>
              <div>
                <img
                  loading="lazy"
                  src="assets/img/icon/check_1.png"
                  alt="icon"
                />{" "}
                <strong>End-to-End Services</strong>
                <p>
                  From designing to developing a marketing presence, we cover it
                  all. We also offer continuous support and maintenance to mark
                  the digital journey of the system.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="shape-mockup" data-bottom="0" data-right="0">
          <div className="particle-3" id="particle-4"></div>
        </div>
      </div>

      {/* Enquiry Form */}
      <div
        className="space"
        id="contact-sec"
        style={{
          backgroundImage: `url('assets/img/bg/appointment_bg_1.jpg')`,
        }}
        data-bg-src=""
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-6 pe-xxl-5 mb-40 mb-xl-0">
              <div className="title-area mb-35 text-xl-start text-center">
                <h2 className="sec-title">
                  Build Your Dream Website with <br />
                  <span className="text-theme">Expert Developers</span>
                </h2>
              </div>

              <p className="mt-n2 mb-30 text-xl-start text-center">
                Our expert develops high-quality websites with visually
                appealing appearances. Our team offers website development and
                custom web-design for businesses to achieve their goals. From
                e-commerce web-design to CMS-based site development. We ensure a
                scalable and optimized platform. We specialize in website
                development, offering customized solutions for better brand
                identity. With a high-performing and SEO-optimized platform. Our
                developers use the latest technologies to ensure a website that
                works fast, is scalable, and is user-friendly.
              </p>
              <NavLink to="/contact-us" className="th-btn">
                CONTACT US<i className="fa-regular fa-arrow-right ms-2"></i>
              </NavLink>
            </div>
            <div className="col-xl-6 ps-xl-4">
              <h3 className="h4 mt-n2 mb-30 text-center">Enquiry Now</h3>
              <EnquiryForm />
            </div>
          </div>
        </div>
      </div>

      {/* Our Website Development  */}
      <OurWebsiteDevelopment/>

      {/* Warrgyizmorsch' Digital Marketing Services  */}
      <DigitalMarketingServicesSection />

      {/* Client Testimonial section  */}
      <ClientTestimonialSection />

      {/* Gallery section  */}
      <section
        className="overflow-hidden bg-white space"
        data-overlay="overlay1"
        data-opacity="2"
      >
        <div className="container th-container5">
          <div className="row">
            <div className="col-xl-4">
              <div className="title-area mb-50 text-center text-md-start">
                <span className="sub-title">Stories</span>
                <h2 className="sec-title">
                  Our work that inspired you to work with us
                </h2>
              </div>
              <div className="project-btn">
                <a href="/gallery" className="th-btn style-border style-radius">
                  View All
                </a>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="slider-area project-slider4">
                <div className="swiper-wrapper">
                  <ProductSlider cardData={galleryHTMLData} slidesPerView={2} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ  */}
      <div className="bg-smoke overflow-hidden space" id="faq-sec">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="title-area text-center text-xl-start">
                <h2 className="sec-title">
                  Custom Web Development Services:{" "}
                  <span className="text-theme fw-normal">
                    Frequently Asked Question?
                  </span>
                </h2>
              </div>
              <div className="accordion-area accordion" id="faqAccordion">
                {/* FAQ 1 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-1">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-1"
                      aria-expanded="false"
                      aria-controls="collapse-1"
                    >
                      What is a Web Development Service?
                    </button>
                  </div>
                  <div
                    id="collapse-1"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-1"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        Web Development Services offers services like designing,
                        building, and maintaining the website for the businesses
                        or the individual business. It ensures that the website
                        is fully functioning, visually appealing, and optimized
                        for performance. Developing a simple complex web
                        application. It helps businesses in recognising the
                        business online.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ 2 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-2">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-2"
                      aria-expanded="false"
                      aria-controls="collapse-2"
                    >
                      What's the cost of your Software Development Services?
                    </button>
                  </div>
                  <div
                    id="collapse-2"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-2"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        The cost of the software services is based on the
                        complexity of the project. LIke the features and the
                        timeline of the projects. The cost of the software
                        depends on factors like project complexity, features,
                        technologies used, and timeline. Contact us for the
                        personalised quote based on the requirement. Higher
                        functionality with best price availability.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ 3 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-3">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-3"
                      aria-expanded="false"
                      aria-controls="collapse-3"
                    >
                      What do web development services include?
                    </button>
                  </div>
                  <div
                    id="collapse-3"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-3"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        Web development services include custom solutions,
                        front-end development, back-end development, e-commerce
                        solutions, and content management system (CMS)
                        development.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ 4 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-4"
                      aria-expanded="false"
                      aria-controls="collapse-4"
                    >
                      How can I optimize a web app for SEO?
                    </button>
                  </div>
                  <div
                    id="collapse-4"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-4"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        To improve and optimized the search engine visibility of
                        your web application, consider the following:
                      </p>
                      <ul>
                        <li>Optimize site speed for faster load times.</li>
                        <li>
                          Ensure mobile responsiveness to provide a seamless
                          experience on all devices.
                        </li>
                        <li>
                          Use metadata optimization for better indexing by
                          search engines.
                        </li>
                        <li>
                          Implement structured data (schema markup) to enhance
                          search rankings.
                        </li>
                        <li>
                          Improve internal linking and URL structure for better
                          navigation.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* FAQ 5 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-5">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-5"
                      aria-expanded="false"
                      aria-controls="collapse-5"
                    >
                      What web development services does Warrgyizmorsch offer?
                    </button>
                  </div>
                  <div
                    id="collapse-5"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-5"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        Warrgyizmorsch offers custom web development, eCommerce
                        web design, CMS solutions, SEO optimization, and custom
                        software development. We assure the best quality of the
                        projects before time.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ 6 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-6">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-6"
                      aria-expanded="false"
                      aria-controls="collapse-6"
                    >
                      How is the web development team structured?
                    </button>
                  </div>
                  <div
                    id="collapse-6"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-6"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        Our web development team consists of:
                      </p>
                      <ul>
                        <li>
                          Front-End Developers – Experts in creating visually
                          appealing interfaces.
                        </li>
                        <li>
                          Back-End Developers – Skilled in databases, APIs, and
                          server management.
                        </li>
                        <li>
                          UI/UX Designers – Ensuring intuitive user experiences.
                        </li>
                        <li>
                          SEO Specialists – Enhancing website visibility and
                          rankings.
                        </li>
                        <li>
                          Content Strategists & Writers – Creating engaging and
                          optimized content.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* FAQ 7 */}
                <div className="accordion-card">
                  <div className="accordion-header" id="collapse-item-7">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-7"
                      aria-expanded="false"
                      aria-controls="collapse-7"
                    >
                      How do you control the quality of the software you
                      deliver?
                    </button>
                  </div>
                  <div
                    id="collapse-7"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-7"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">
                        We follow a top-quality assurance process, which
                        includes:
                      </p>
                      <ul>
                        <li>
                          Agile Development Practices – Ensuring flexibility and
                          efficiency.
                        </li>
                        <li>
                          Continuous Testing – Conducting real-time testing
                          throughout development.
                        </li>
                        <li>
                          Performance Optimization – Enhancing speed, security,
                          and usability.
                        </li>
                        <li>
                          Bug Fixing & Debugging – Identifying and resolving
                          potential issues.
                        </li>
                        <li>
                          Post-Launch Support – Ongoing updates and maintenance
                          for long-term success.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Blog Slider Section  */}
      <BlogListingSlider />
    </>
  );
};

export default Test;
